import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { AppRouteReuseStrategy } from './routing/app-route-reuse.strategy';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { businessContextInterceptor } from './interceptors/business-context.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    provideHttpClient(withInterceptors([businessContextInterceptor, errorInterceptor])),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
